import React from 'react';
import { Icon } from 'components/ui/icon';
import CURRENCY from 'utils/currency';
import { PAYMENTS } from 'state/payment/type';
import Table, { ColumnConfig } from 'components/table';
import usePayment from 'state/payment/hooks/usePayment';
import TransactionsAccordion from 'components/summary-tab/accordions/transactions';

const SummaryByPaymentType = () => {
  const { payment } = usePayment();
  const { transactionSummary: summary } = payment;
  const is_validate_summary_data =
    summary?.aggregate_transaction_amount?.some(
      (dict) =>
        dict?.gross_amount > 0 ||
        dict?.transaction_count > 0 ||
        dict?.order_amount > 0 ||
        dict?.tip_amount > 0
    ) || false;

  const COLUMNS: ColumnConfig<PAYMENTS.ITransactionSummaryByPaymentType>[] = [
    {
      key: 'method',
      label: 'Gross Receipts by "Payment types"',
      renderCell: (row) => (
        <div>{row.method === 'ATM' ? 'CATM' : row.method}</div>
      ),
    },
    {
      key: 'gross_amount',
      label: '',
      renderCell: (row) => (
        <div className="text-gray-blue-60 font-medium text-left">
          {row.gross_amount
            ? CURRENCY.convertToMainUnit(row.gross_amount)
            : '$0.00'}
        </div>
      ),
    },
    {
      key: 'transaction_count',
      label: '',
      renderCell: (row) => <div>{row.transaction_count || 0}</div>,
    },
    {
      key: 'gross_amount',
      label: '',
      renderCell: (row) => (
        <div className="text-gray-blue-60 font-medium text-left">
          {row.gross_amount && row.transaction_count
            ? CURRENCY.convertToMainUnit(
                row.gross_amount / row.transaction_count
              )
            : '$0.00'}
        </div>
      ),
    },
  ];

  const expandRowRenderer = (
    row: PAYMENTS.ITransactionSummaryByPaymentType
  ) => (
    <div className="w-full pl-0">
      <TransactionsAccordion row={row} />
    </div>
  );

  return (
    <Table
      data={summary?.aggregate_transaction_amount || []}
      columns={COLUMNS}
      isEmpty={!is_validate_summary_data}
      theme={{
        showTableBorder: true,
        tableGridLayout: 'auto 1.5fr 1fr 1fr 1fr',
      }}
      customTheme={{
        HeaderCell: `
            height: 64px;
            background-color: #fff !important;
            font-size: 16px !important;
            line-height: 24px !important;
            text-transform: none !important;
            letter-spacing: 0px !important;
        `,
        Cell: `height: 52px;`,
        Table: `border-radius: 4px; margin-top: 12px;`,
        Row: `
              & > td:first-child {
                border-bottom-left-radius: 4px;
              }
              & > td:last-child {
                border-bottom-right-radius: 4px;
              }
            `,
      }}
      rowExpand={{
        renderer: expandRowRenderer,
        className: 'dropdownArea px-8',
        position: 'left',
        columnRenderer: (expanded: boolean) => {
          return (
            <span className="flex justify-center items-center">
              {expanded ? (
                <Icon name="chevron-down" size={16} />
              ) : (
                <Icon name="chevron-right" size={16} />
              )}
            </span>
          );
        },
      }}
    />
  );
};

export default SummaryByPaymentType;
